module.exports = __webpack_public_path__ + "media/email/rm_sig-a462dcb0.png";